<div class="flex flex-col gap-2" style="padding: 10px">
  <h2>Keys</h2>
  <span style="width: 100%;border-top: 1px solid grey"></span>

  <!-- <div class="flex flex-row">
    <mat-form-field class="flex-1 min-w-[30%] sm:min-w-full">
      <input matInput id="listFilter" (keyup)="filterTable($event)" placeholder="Filter"
        value="{{listFilter}}" />

      <button *ngIf="listFilter" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </div> -->
<mat-tab-group dynamicHeight [(selectedIndex)]="keysTab">

  <mat-tab label="Lab Type Key">
    <div class="flex flex-col">
      <h4>Lab Type Key </h4>
      <span style="width: 100%;border-top: 1px solid grey"></span>

      <table class="w-full" class="mat-elevation-z8 ">
        <thead>
        <tr class="keyHeader">
          <th>Lab Type </th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of labTypeList">
          <td>{{item.key}}</td>
          <td>{{item.value}}</td>
        </tr>
      </tbody>
      </table>
    </div>
  </mat-tab>

  <mat-tab label="Schedule Key">
    <div class="flex flex-col">
      <h4>Schedule Key</h4>
      <span style="width: 100%;border-top: 1px solid grey"></span>

      <table class="w-full" class="mat-elevation-z8 ">
        <tr class="keyHeader">
          <th>Key </th>
          <th>Description</th>
        </tr>
        <tr *ngFor="let item of scheduleKeyList">
          <td>{{item.key}}</td>
          <td>{{item.value}}</td>
        </tr>
      </table>
    </div>
  </mat-tab>

  <mat-tab label="Accreditation Key">
    <div class="flex flex-col">
      <h4>Accreditation Key</h4>
      <span style="width: 100%;border-top: 1px solid grey"></span>

      <table class="w-full" class="mat-elevation-z8 ">
        <tr *ngFor="let item of accreditationKeyList">
          <td>{{item.key}}</td>
          <td>{{item.value}}</td>
          <td>{{item.misc}}</td>
        </tr>
      </table>
    </div>
  </mat-tab>

  <mat-tab label="Proficiency Tests">
    <div class="flex flex-col">
      <h4>Proficiency Tests</h4>
      <span style="width: 100%;border-top: 1px solid grey"></span>

      <div class="flex flex-col">
        <div class="flex flex-row">
          <mat-form-field class="flex-1 min-w-[30%] sm:min-w-full">
            <input matInput id="listFilter" (keyup)="filterTable($event)" placeholder="Filter"
              value="{{listFilter}}" />

            <button *ngIf="listFilter" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div style="overflow-x:auto">
          <div class="flex flex-row">
            <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort"
              class="mat-elevation-z8 w-full" matSortActive="majorCat" matSortDirection="asc">
              <ng-container matColumnDef="ptTest">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>PT Test</th>
                <td mat-cell *matCellDef="let category">{{category.ptTest}}</td>
              </ng-container>
              <ng-container matColumnDef="specialty">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Specialty</th>
                <td mat-cell *matCellDef="let category">{{category.specialty}}</td>
              </ng-container>
              <ng-container matColumnDef="subSpecialty">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Sub Specialty</th>
                <td mat-cell *matCellDef="let category">{{category.subSpecialty}}</td>
              </ng-container>
              <ng-container matColumnDef="testCode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Test Code</th>
                <td mat-cell *matCellDef="let category">{{category.tCode}}</td>
              </ng-container>
              <ng-container matColumnDef="tId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Test ID</th>
                <td mat-cell *matCellDef="let category">{{category.tId}}</td>
              </ng-container>
              <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Code</th>
                <td mat-cell *matCellDef="let category">{{category.tId}}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
        </div>
      </div>
</div>
  </mat-tab>

  <mat-tab label="Specialties">
    <div class="flex flex-col">
      <h4>Specialties</h4>
      <span style="width: 100%;border-top: 1px solid grey"></span>

      <table class="w-full" class="mat-elevation-z8 ">
        <tr class="keyHeader">
          <th>T CD</th>
          <th>Specialty</th>
          <th>Sub Specialty</th>
          <th>PT</th>
        </tr>
        <tr *ngFor="let item of specialtiesList">
          <td>{{item.t_CD}}</td>
          <td>{{item.majorCat}}</td>
          <td>{{item.licAbbrev}}</td>
          <td>{{item.pt}}</td>
        </tr>
      </table>
    </div>
  </mat-tab>

  <mat-tab label="Survey Types">
    <div class="flex flex-col">
      <h4>Surveys Types</h4>
      <span style="width: 100%;border-top: 1px solid grey"></span>

      <table class="mat-elevation-z8 w-full">
        <tr class="keyHeader">
          <th>Key</th>
          <th>Description</th>
        </tr>
        <tr *ngFor="let item of surveysTypesList">
          <td>{{item.key}}</td>
          <td>{{item.value}}</td>
        </tr>
      </table>
    </div>
  </mat-tab>

  <mat-tab label="Complexity">
    <div class="flex flex-col">
      <h4>Complexity</h4>
      <span style="width: 100%;border-top: 1px solid grey"></span>

      <table class="mat-elevation-z8 w-full">
        <tr class="keyHeader">
          <th>Key</th>
          <th>Description</th>
        </tr>
        <tr *ngFor="let item of complexityList">
          <td>{{item.key}}</td>
          <td>{{item.value}}</td>
        </tr>
      </table>
    </div>
  </mat-tab>

  <mat-tab label="Certificate Types">
    <div class="flex flex-col">
      <h4>Certificate Types</h4>
      <span style="width: 100%;border-top: 1px solid grey"></span>

      <table class="mat-elevation-z8 w-full">
        <tr class="keyHeader">
          <th>Key </th>
          <th>Description</th>
        </tr>
        <tr *ngFor="let item of certificateTypeList">
          <td>{{item.key}}</td>
          <td>{{item.value}}</td>
        </tr>
      </table>
    </div>
  </mat-tab>


</mat-tab-group>
<span style="width: 100%;border-top: 1px solid grey"></span>

<div class="flex flex-row">
  <button mat-raised-button style="border-top: 20px;" (click)="close()">Close</button>
</div>
</div>